(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // H25 (2026-06-16): the header is permanently pinned and never hides.
      // Pin via the theme's own `-sticky` class (position:sticky + z-index:100, which
      // the theme already wires up correctly for the search / menu / cart overlays) as
      // soon as the page is scrolled past the header's resting top edge; return it to
      // normal flow only at/above that point so the overlays stack correctly near the
      // top of the page. The original hide-on-scroll-down branch is intentionally gone.
      const threshold = this.headerBounds.top;
      if (threshold == null || scrollTop <= threshold) {
        requestAnimationFrame(this.reset.bind(this));
      } else {
        requestAnimationFrame(this.reveal.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      // H25 (2026-06-16): never hide. Safe no-hide alias of reveal() in case any
      // theme code path still calls hide() directly.
      this.reveal();
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // H25 (2026-06-16): announcement bar collapses on scroll-down and re-appears on
  // scroll-up, sitting above the permanently-pinned header. Direction detection uses
  // an accumulator + a state guard so momentum / sub-pixel scroll jitter on real
  // devices cannot flip the header back and forth ("twitch").
  (function () {
    var ann = document.querySelector('.shopify-section-announcement-bar');
    if (!ann) return;
    var body = document.body;
    var lastY = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
    var revealed = false;
    var accUp = 0, accDown = 0;
    var UP_TOL = 24;   // intentional scroll-up distance needed to bring the bar back
    var DOWN_TOL = 24; // symmetric so momentum jitter cannot flip the state either way
    var ticking = false;
    var lastH = -1;

    function measure() {
      var h = ann.offsetHeight;
      if (h !== lastH) { lastH = h; document.documentElement.style.setProperty('--h25-ann-h', h + 'px'); }
    }
    function setReveal(on) {
      if (on === revealed) return; // guard: never re-toggle the same state -> no twitch
      revealed = on;
      body.classList.toggle('h25-ann-reveal', on);
    }
    function update() {
      ticking = false;
      var y = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
      var dy = y - lastY;
      lastY = y;
      var annH = ann.offsetHeight;
      if (y <= annH + 2) { setReveal(false); accUp = accDown = 0; return; }
      if (dy < 0) {            // scrolling up
        accUp -= dy; accDown = 0;
        if (accUp > UP_TOL) setReveal(true);
      } else if (dy > 0) {     // scrolling down
        accDown += dy; accUp = 0;
        if (accDown > DOWN_TOL) setReveal(false);
      }
    }

    measure();
    window.addEventListener('resize', measure, { passive: true });
    if (window.ResizeObserver) { new ResizeObserver(measure).observe(ann); }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
